module.exports = __webpack_public_path__ + "img/z08.6fb7f859.jpg";